import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions } from '@angular/router';

const routes: Routes = [
  {
    path: 'product',
    loadChildren: () => import('./product-services/product-services.module').then(m => m.ProductServicesModule)
  },
  {
    path: 'contact-us',
    loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactUsModule)
  },
  {
    path: 'company',
    loadChildren: () => import('./company/company.module').then(m => m.CompanyModule)
  }, 
  {
    path: 'support',
    loadChildren: () => import('./support/support.module').then(m => m.SupportModule)
  }, 
  {
    path: 'news',
    loadChildren: () => import('./news/news.module').then(m => m.NewsModule)
  }, 
  {
    path: 'coverage',
    loadChildren: () => import('./coverage/coverage.module').then(m => m.CoverageModule)
  },
  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
